import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignedBuildings: [],
  buildingOptions: [],
};

const customerBuildingsSlice = createSlice({
  name: "customerBuildings",
  initialState,
  reducers: {
    setAssignedBuildings(state, action) {
      state.assignedBuildings = action.payload;
    },
    setBuildingOptions(state, action) {
      state.buildingOptions = action.payload;
    },
    updateBuildingInState(state, action) {
      const updatedBuilding = action.payload;
      const index = state.assignedBuildings.findIndex(
        (b) => b.buildingID === updatedBuilding.buildingID
      );
      if (index !== -1) {
        state.assignedBuildings[index] = updatedBuilding;
      }
    },
    addBuildingToState(state, action) {
      state.assignedBuildings.push(action.payload);
    },
    removeBuildingFromState(state, action) {
      const buildingID = action.payload;
      state.assignedBuildings = state.assignedBuildings.filter(
        (b) => b.buildingID !== buildingID
      );
    },
  },
});

export const {
  setAssignedBuildings,
  setBuildingOptions,
  updateBuildingInState,
  addBuildingToState,
  removeBuildingFromState,
} = customerBuildingsSlice.actions;

export default customerBuildingsSlice.reducer;
